import {DestroyRef, inject, provideAppInitializer} from '@angular/core';
import {Actions, ofActionDispatched, Store} from '@ngxs/store';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {CreateOrg, SetOnboardingStateOp} from '../../org/onboarding/+state/actions';
import {catchError, map, switchMap} from 'rxjs';
import {OrgOnboardingState} from '../../org/onboarding/+state/state';
import {mapToCreateOrgRequestModel} from '../model/create-org-details-form.model';
import {HttpClient} from '@angular/common/http';
import {getApiUrl} from '../helpers/env.helper';

export const provideCreateOrgInit = provideAppInitializer(() => {
  const actions = inject(Actions);
  const store = inject(Store);
  const destroyRef = inject(DestroyRef);

  const httpClient = inject(HttpClient);

  actions.pipe(
    ofActionDispatched(CreateOrg),
    switchMap(() => getApiUrl('iam')),
    switchMap((url) =>
      store.dispatch(new SetOnboardingStateOp('pending')).pipe(
        map(() => store.selectSnapshot(OrgOnboardingState.state)),
        map(({ orgDetails, teammates = {} }) => {
          if (!orgDetails) {
            throw new Error('Org details not found');
          }
          return mapToCreateOrgRequestModel(orgDetails, teammates);
        }),
        switchMap(org => httpClient.post(`${url}/orgs`, org).pipe(
          switchMap(() => store.dispatch(new SetOnboardingStateOp('success'))),
        )),
        catchError((err) => {
          console.error('Error creating org', err);
          return store.dispatch(new SetOnboardingStateOp('error'));
        })
      )
    ),
    takeUntilDestroyed(destroyRef)
  ).subscribe();
});
